import './index.scss';
import WebViewer from '@pdftron/webviewer';
import React, { useEffect, useRef, useState } from 'react';
import { renderHighlights } from './annotations';
import config from './config';
const PDFViewer = (props) => {
    const { document, highlights, webViewerRef, onDocumentLoadedCallback } = props;
    const [docLoaded, setDocLoaded] = useState(false);
    const viewer = useRef(null);
    const instance = useRef();
    const instanceRef = webViewerRef !== null && webViewerRef !== void 0 ? webViewerRef : instance;
    useEffect(() => {
        WebViewer(config, viewer.current).then(inst => {
            const { documentViewer, annotationManager } = inst.Core;
            inst.UI.loadDocument(document);
            documentViewer.addEventListener('documentLoaded', () => {
                instanceRef.current = inst;
                setDocLoaded(true);
            });
            annotationManager.enableReadOnlyMode();
        });
    }, []);
    useEffect(() => {
        setDocLoaded(false);
        if (!instanceRef.current)
            return;
        instanceRef.current.UI.loadDocument(document);
    }, [document]);
    useEffect(() => {
        if (!instanceRef.current || !highlights || !docLoaded)
            return;
        renderHighlights(highlights, instanceRef.current);
    }, [highlights, docLoaded]);
    useEffect(() => {
        if (!instanceRef.current || !onDocumentLoadedCallback || !docLoaded)
            return;
        onDocumentLoadedCallback();
    }, [onDocumentLoadedCallback, docLoaded]);
    return React.createElement("div", { className: 'webviewer', ref: viewer });
};
export default PDFViewer;
